/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { Grid } from '@elliemae/ds-grid';
import { styled } from '@elliemae/ds-system';

const CardIconsWrapper = styled(Grid)`
  align-items: center;
  span,
  svg {
    width: 12px !important;
    height: 12px !important;
  }
  span.icon-color-muted svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.neutral['600']};
    height: 12px !important;
    width: 12px !important;

    & * {
      fill: ${(props) => props.theme.colors.neutral['600']};
    }
  }
  span.icon-color-warn svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.warning['600']};
    height: 12px !important;
    width: 12px !important;

    & * {
      fill: ${(props) => props.theme.colors.warning['600']};
    }
  }
  span.icon-color-error svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.danger['900']};
    height: 12px !important;
    width: 12px !important;

    & * {
      fill: ${(props) => props.theme.colors.danger['900']};
    }
  }
  span.icon-color-success svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.success['900']};
    height: 12px !important;
    width: 12px !important;

    & * {
      fill: ${(props) => props.theme.colors.success['900']};
    }
  }
  span.icon-color-primary svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.brand[600]};
  }
  span.icon-color-primary svg,
  svg:not([fill]) {
    fill: ${(props) => props.theme.colors.brand[600]};
  }
`;

export const SubIcons = ({ icons = [], colors = [] }) => (
  <CardIconsWrapper cols={icons.map(() => '12px')} gutter="6px" height="14px" data-testid="card-subIcons">
    {icons.map((Icon, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Icon key={i} className={`icon-color-${colors[i] || 'muted'}`} />
    ))}
  </CardIconsWrapper>
);
